import { isFieldPartIdentifier, isFieldGroupPartIdentifier, isSectionGroupPartIdentifier, isSectionPartIdentifier, isSelectOptionPartIdentifier, isSubsectionPartIdentifier, } from './blueprintIdentifiers';
export function isBlueprintCreation(modification) {
    return !!modification.create;
}
export function isBlueprintReplacement(modification) {
    return !!modification.replacement;
}
export function isBlueprintUpdate(modification) {
    return !!modification.update;
}
export function isBlueprintRemoval(modification) {
    return !!modification.remove;
}
export function isBlueprintReorder(modification) {
    return !!modification.reorder;
}
export function isSectionBlueprintCreation(blueprintCreation) {
    // Don't need to specify a parent item when creating a section.
    return blueprintCreation.partIdentifier === null;
}
export function isSubsectionBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return isSectionPartIdentifier(blueprintCreation.partIdentifier);
}
export function isFieldGroupBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return isSubsectionPartIdentifier(blueprintCreation.partIdentifier);
}
export function isFieldBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return isFieldGroupPartIdentifier(blueprintCreation.partIdentifier);
}
export function isSelectOptionBlueprintCreation(blueprintCreation) {
    // Container elements are specified when creating a sub-item.
    return isFieldPartIdentifier(blueprintCreation.partIdentifier);
}
export function isSectionGroupBlueprintUpdate(blueprintUpdate) {
    return isSectionGroupPartIdentifier(blueprintUpdate.partIdentifier);
}
export function isSectionBlueprintUpdate(blueprintUpdate) {
    return isSectionPartIdentifier(blueprintUpdate.partIdentifier);
}
export function isSubsectionBlueprintUpdate(blueprintUpdate) {
    return isSubsectionPartIdentifier(blueprintUpdate.partIdentifier);
}
export function isFieldGroupBlueprintUpdate(blueprintUpdate) {
    return isFieldGroupPartIdentifier(blueprintUpdate.partIdentifier);
}
export function isFieldBlueprintUpdate(blueprintUpdate) {
    return isFieldPartIdentifier(blueprintUpdate.partIdentifier);
}
export function isSelectOptionBlueprintUpdate(blueprintUpdate) {
    return isSelectOptionPartIdentifier(blueprintUpdate.partIdentifier);
}
export function isSectionBlueprintReorder(blueprintReorder) {
    return isSectionPartIdentifier(blueprintReorder.partIdentifier);
}
export function isSubsectionBlueprintReorder(blueprintReorder) {
    return isSubsectionPartIdentifier(blueprintReorder.partIdentifier);
}
export function isFieldGroupBlueprintReorder(blueprintReorder) {
    return isFieldGroupPartIdentifier(blueprintReorder.partIdentifier);
}
export function isFieldBlueprintReorder(blueprintReorder) {
    return isFieldPartIdentifier(blueprintReorder.partIdentifier);
}
export function isSelectOptionBlueprintReorder(blueprintReorder) {
    return isSelectOptionPartIdentifier(blueprintReorder.partIdentifier);
}
